import React from 'react';
import t from "../../../../../helpers/t";
import {moment} from "../../../../../../../vendor";
import {Biscuit} from "../../../../../../utils";
import {rbac} from "../../../index";

const WebView = (props) => {
    const {usergroup, index, deleteUserGroupPending, onDeleteUserGroup, currentUrl, getList} = props;
    return (
        <>
            <div className={"inb-c-item inb-c-item--order hide-for-small-only"} key={index}>
                {/* {Biscuit.get('user.is_superuser')  === 'true' &&  <aside className="inb-c-item__actions">
                          <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="right"
                                          bsPrefix="button round inb-toggle-contingent-dd hover">
                            <ul className="inb-dropdown__list">
                              <li data-inb-action-link='changelog' id="kln_changelog">
                                <Dropdown.Item href='#' onClick={() => openChangeLog(usergroup.changeLogs)}>
                                  <i className="fi fi-wrench"> </i>
                                  {t('changelog', null, 'capital')}
                                </Dropdown.Item>
                              </li>
                            </ul>
                          </DropdownButton>


                        </aside>}*/}
                <div className="large-2 medium-8 small-8 column show-label" title={t('id',null,'capital')} >
                    <span>{usergroup.id}</span>
                </div>
                <div className="large-2 medium-8 small-8 column show-label" title={t('name',null,'capital')} >
                    <span>{usergroup.name}</span>
                </div>
                <div className="large-2 medium-8 small-8 column show-label" title={t('domain',null,'capital')} >
                    <span>{usergroup.domain}</span>
                </div>
                    <div className="large-4 medium-offset-0 medium-8 item-button-group column" id="edit-delete-button-group" style={{top:0}}>
                        &nbsp;
                    </div>
                    <div className="large-1 medium-offset-0 medium-8 item-button-group column" id="edit-delete-button-group" style={{top:0}}>

                        <div className="button-container" id="list">
                            { rbac.hasPermission('editUser') &&
                                <a
                                    href={"/usersExtension/userGroups/"+usergroup.id+'?path=' + '/usersExtension/userGroups'+ currentUrl.search}
                                    title={t('edit')}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left">
                                        <div className="inb-fi-edit"></div>
                                    </button>
                                </a>
                            }
                        </div>
                        <div className="button-container" >
                            { rbac.hasPermission('delete') &&
                                <>
                                    {deleteUserGroupPending !== index?<>
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={t('delete')}>
                                            <button type="button" className="inb-round-btn hollow round float-left" onClick={ () => onDeleteUserGroup(usergroup,index)}>
                                                <div className="inb-fi-remove"></div>
                                            </button>
                                        </a>
                                    </>: <>
                                        <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                    </>
                                    }</>}
                        </div>
                    </div>

                    <div className="large-1 medium-offset-0 medium-8 item-button-group column btn-grp-2" id="list-user-button" style={{top:0}}>
                        <div className="button-container">
                            <a
                                href="#"
                                title={t('list')}
                                data-inb-action-link="list"
                                onClick={e => getList(e,usergroup)}
                            >
                                <button type="button" className="inb-round-btn hollow round float-left">
                                    <div className="inb-fi-list"></div>
                                </button>
                            </a>
                        </div>
                    </div>
            </div>
        </>
    );
}

export default WebView;